import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { InstrumentoLCSLHPTIDTO, InstrumentoLCSLHPTIFormData } from './types'

const getEndpoint = (url = '') => `operacion-lcslhpti/instrumentos${url}`

export const HttpInstrumentoLCSLHPTI = {
    getPorPais: (sinCodPais: number): Promise<InstrumentoLCSLHPTIDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/${sinCodPais}`)),

    insert: (data: InstrumentoLCSLHPTIFormData): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(), data),

    update: (id: number, data: InstrumentoLCSLHPTIFormData): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint(`/${id}`), data),

    updateOrden: (data: {
        sinCodOperacionLCSLHPInstrumentoSube: number
        tinOrdenSube: number
        sinCodOperacionLCSLHPInstrumentoBaja: number
        tinOrdenBaja: number
    }): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint('/orden'), data),

    deactivate: (id: number): Promise<any> =>
        HttpAxiosRequest.delete(getEndpoint(`/${id}`))
}
